// Read the same selling plan that will be submitted to Shopify. Recharge owns
// that selection; this component updates unit prices and pack savings together.
if (!customElements.get('tcd-price-per-can')) {
  customElements.define(
    'tcd-price-per-can',
    class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-price-per-can], [data-pack-savings]'), (element) => ({
          element,
          oneTimePrice: element.dataset.oneTimePrice,
          plans: JSON.parse(element.dataset.planPrices),
        }));
        this.section = this.closest('product-info');
        this.sync = this.updatePrices.bind(this);
        this.section?.addEventListener('change', this.sync);
        this.section?.addEventListener('input', this.sync);
        this.observer = new MutationObserver(this.sync);
        if (this.section) {
          this.observer.observe(this.section, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['value', 'checked', 'disabled'],
          });
        }
        // Setting an input's value property need not emit an event or mutation.
        // Also covers late widget initialization and replacement of form inputs.
        this.timer = setInterval(this.sync, 250);
        this.updatePrices();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
        this.section?.removeEventListener('change', this.sync);
        this.section?.removeEventListener('input', this.sync);
      }

      updatePrices() {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;

        const planInput = Array.from(form.elements).find(
          (input) =>
            input.name === 'selling_plan' &&
            !input.matches(':disabled') &&
            (!['radio', 'checkbox'].includes(input.type) || input.checked)
        );
        const planId = planInput?.value || '';
        for (const card of this.cards) {
          const { element, oneTimePrice, plans } = card;
          // Do not misrepresent an ineligible pack as having the active plan's
          // discount. Its label returns once a supported plan is selected.
          const price = planId ? plans[planId] : oneTimePrice;
          element.hidden = price == null;
          if (price != null && card.lastPrice !== price) element.innerHTML = price;
          card.lastPrice = price;
        }
      }
    }
  );
}
